import { render, staticRenderFns } from "./upLoadAttachment.vue?vue&type=template&id=bd0b6c04&"
import script from "./upLoadAttachment.vue?vue&type=script&lang=js&"
export * from "./upLoadAttachment.vue?vue&type=script&lang=js&"
import style0 from "./upLoadAttachment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports